
import {
  OnInit,
  Input,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { Usuario } from '../models/usuario.model';

@Component({
  selector: 'iw-button-download-review',
  template: '<p class="m-0"' +
              '>{{ nameUser }} <i *ngIf="userSelect" class="fa fa-check-circle" style="color: green;">' +
            '</i></p>',
  styles: [],
  encapsulation: ViewEncapsulation.None
})
export class NameUserAssignmentComponent implements ViewCell, OnInit {
  // entrada del valor del boton
  @Input() value: any;
  // entrada de la fila
  @Input() rowData: Usuario;
  // Contiene el nombre de usuario
  nameUser = '';
  // Define si el registro es un usuario seleccionado
  userSelect = false;

  ngOnInit() {
    this.nameUser = this.rowData.first_name + ' ' + this.rowData.last_name;
    if (this.rowData['select']) {
      this.userSelect = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/name-user-assignment.component.ts